<button (click)="logout()" mat-button>
  <mat-icon>logout</mat-icon>
  Log out
</button>
